export function inferFieldComponent(column) {
  if (!column) return 'string';
  const { type, enum: enumValues, format, uiHint } = column;

  // 1. JSON
  if (type === 'object' || type === 'array') return 'json-dialog';

  // 2. Boolean
  if (type === 'boolean') return 'boolean';

  // 3. Select (Enum)
  if (Array.isArray(enumValues) && enumValues.length > 0) return 'select';

  // 4. Format tiene prioridad sobre type para los tipos de string especializados
  if (format === 'date-time' || format === 'datetime') return 'datetime';
  if (format === 'date')                                return 'date';
  if (format === 'time')                                return 'time';
  if (format === 'email')                               return 'email';
  if (format === 'uri' || format === 'url')             return 'url';

  // 5. Fallback a type
  if (type === 'datetime' || type === 'date-time')      return 'datetime';
  if (type === 'date')                                  return 'date';
  if (type === 'time')                                  return 'time';
  if (type === 'email')                                 return 'email';
  if (type === 'url' || type === 'uri')                 return 'url';

  // 6. UI hint
  if (uiHint === 'textarea')                            return 'textarea';

  // 7. Auto-promote long strings
  if ((type === 'string' || !type) && (column.maxLength ?? 0) > 200) return 'textarea';

  // 8. Number / Integer
  if (type === 'number' || type === 'integer')          return 'number';

  // 9. Default
  return 'string';
}